import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_7: FaireProductEntity = {
  token: "ramen-7",
  type: "product",
  name: "Spicy Hotpot Noodles",
  brandName: "Hotpot Queen",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7351c53dc724c686ade531321d7de9ac71fef1d843d873d614cf26dc23e8bf27.png",
  priceDollars: 2.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/7351c53dc724c686ade531321d7de9ac71fef1d843d873d614cf26dc23e8bf27.png",
  weight: 0.3,
  dimensions: {
    width: 6,
    height: 8,
    depth: 2,
  },
  description: "Spicy hotpot noodles with bold flavor",
  categoryTokens: ["cat_food-snacks"],
  tags: [
    "ramen",
    "instant-ramen",
    "japanese-ramen",
    "hotpot",
    "spicy",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
